import { createContext } from '@lit/context';
import { CartState } from './wishlist-state.js';

export const cartContext = createContext<CartState>(Symbol('cart-context'));
